module.exports = __webpack_public_path__ + "img/this-could-be-you.e40ffa4e.jpg";